'use client';

import { ROUTES } from '@shared/utils';
import { StickyPurchaseBar } from '../../StickyPurchaseBar/StickyPurchaseBar';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

/**
 * Renders the sticky "play again" bar for the purchased lottery.
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsStickyBar() {
  const { ticket, lotteryName } = usePurchaseDetails();

  return (
    <StickyPurchaseBar
      lotteryName={lotteryName}
      betUrl={ROUTES.LOTTO.LOTTERIES[lotteryName.toUpperCase() as keyof typeof ROUTES.LOTTO.LOTTERIES]}
      currency={ticket.currency}
      data-track-container="Sticky Button Bar"
    />
  );
}

export { PurchaseDetailsStickyBar };
